import { RemoveUserAccountConnectorApollo } from '@front-activerse/common-components';
import RemoveAccountConfrimContainer from './RemoveAccountConfrimContainer';

const RemoveAccountConfirmPage = () => {
  return (
    <RemoveUserAccountConnectorApollo>
      {(RemoveAccountData) => {
        return <RemoveAccountConfrimContainer {...RemoveAccountData} />;
      }}
    </RemoveUserAccountConnectorApollo>
  );
};

export default RemoveAccountConfirmPage;
